<template>
	<div class="data-list-new">
		<div class="dis-fle ali-cen">
			<div class="flex-1 txt-12">幣對</div>
			<div class="flex-1 txt-12">買入價/目前價</div>
			<div class="flex-1 txt-12">投入額</div>
			<div class="flex-1 txt-12">殖利率</div>
			<div class="flex-1 txt-12">結算時間</div>
			<div class="flex-1 txt-12">開始時間</div>
			<div class="flex-1 txt-12">結束時間</div>
		</div>
		<div class="th-div dis-fle ali-cen">

		</div>
		<div class="cm-empty"> 暂无数据 </div>
	</div>
</template>
<script>
	export default {
		components: {},
		data() {
			return {};
		},
		methods: {

		},
	};
</script>
<style lang="scss" scoped>
	.data-list-new {
		width: 100%;
		height: 550px;
		margin-top: 0;
		text-align: center;
		border: 2px solid #252731;
		padding-top: 15px;
		border-radius: 12px;

		.txt-12 {
			color: #5e5e7a;
		}

		.cm-empty {
			text-align: center;
			color: #5e5e7a;
			margin-top: 100px;
		}
	}
</style>